// initial state
import UserService from '../../api/users';

const state = {
  error: null,
  orgUsers: [],
  orgDetails: {},
  userLoadState: false,
  orgUserLoadState: false,
};

// getters
const getters = {
  getOrgUserLoadState: (state) => {
    return state.orgUserLoadState;
  },
  error: (state) => {
    return state.error;
  },
  getOrgUsers: (state) => {
    return state.orgUsers;
  },
  getOrgDetails: (state) => {
    return state.orgDetails;
  },
  getUserSavedDocuments: (state) => {
    // get user's saved document ids
    if (state.user.hasOwnProperty('saved_documents')) {
      return state.user.saved_documents;
    } else {
      return [];
    }
  },
  getFeatureLicense: (state) => (featureName) => {
    const currentOrg =
      state.orgDetails && Object.keys(state.orgDetails).length > 0
        ? state.orgDetails
        : JSON.parse(sessionStorage.getItem('organization')) || null;
    if (featureName === 'core') {
      return true;
    } else if (
      currentOrg &&
      currentOrg.licensed_features &&
      currentOrg.licensed_features[featureName]
    ) {
      return true;
    } else {
      return false;
    }
  },
};

// actions
const actions = {
  // This action is used for certain routes to re-check auth token validity and to make sure the user still exists in the database -- Called from beforeEach route guard in Vue router
  async getUser({ commit }, payload) {
    const response = await UserService.getUser(payload);
    if (!response.success) {
      commit('setError', response.message);
    }
    return response;
  },
  async getOrgUsers({ commit }, payload) {
    const response = await UserService.getOrgUsers(payload.orgId, payload.role);
    if (!response.success) {
      commit('setError', response.message);
    }
    commit('setOrgUsers', response.data);
    // Set loadState
    commit('setOrgUserLoadState', true);
    return response.data;
  },
  async getOrgDetails({ commit }, orgId) {
    const response = await UserService.getOrgDetails(orgId);
    if (!response.success) {
      commit('setError', response.message);
      return;
    }
    sessionStorage.setItem('organization', JSON.stringify(response.data));
    commit('setOrgDetails', response.data);
    // Set loadState
    commit('setOrgUserLoadState', true);
    return response.data;
  },
  async updateUser({ commit }, payload) {
    const response = await UserService.updateUser(payload.uid, payload.payload);
    if (!response.success) {
      commit('setError', response.message);
      return;
    }
    return response.data;
  },
  async changePassword({ commit }, payload) {
    const response = await UserService.changePassword(
      payload.uid,
      payload.payload
    );
    if (!response.success) {
      commit('setError', response.message);
      // Only return success property
      return response.success;
    }
    return response;
  },
  async updateUserAsAdmin({ commit }, payload) {
    const response = await UserService.updateUserAsAdmin(
      payload.uid,
      payload.payload
    );
    if (!response.success) {
      commit('setError', response.message);
      // Only return success property
      return response.success;
    }
    return response;
  },
  async deleteUser({ commit }, payload) {
    const response = await UserService.deleteUser(payload.uid);
    if (!response.success) {
      commit('setError', response.message);
      // Only return success property
      return response.success;
    }
    return response;
  },
  async createUser({ commit }, payload) {
    const response = await UserService.createUser(payload);
    if (!response.success) {
      commit('setError', response.message);
      return response;
    }
    return response;
  },
  async sendFeedback({ commit }, payload) {
    const response = await UserService.sendFeedback(payload);
    if (!response.success) {
      commit('setError', response.message);
      return response.success;
    }
    return response;
  },
  async askAnAnalyst({ commit }, payload) {
    const response = await UserService.askAnAnalyst(payload);
    if (!response.success) {
      commit('setError', response.message);
      return response.success;
    }
    return response;
  },
  async requestUpgrade({ commit }, payload) {
    const response = await UserService.requestUpgrade(payload);
    if (!response.success) {
      commit('setError', response.message);
      return response.success;
    }
    return response;
  },
  async updateOrgName({ commit, dispatch }, payload) {
    const response = await UserService.updateOrgName(payload.orgId, payload.name);
    if (!response.success) {
      commit('setError', response.message);
      return response.success;
    }
    await dispatch('getOrgDetails', payload.orgId);
    return response;
  },
  async getOrgUnits({ commit }, payload) {
    const response = await UserService.getOrgUnits();
    if (!response.success) {
      commit('setError', response.message);
      return;
    }

    return response.data;
  },
  async resendInvite({ commit }, uid) {
    const response = await UserService.resendInvite(uid);
    if (!response.success) {
      commit('setError', response.message);
    }
    return response;
  },
};

// mutations
const mutations = {
  userState(state, payload) {
    // adds user profile info to store
    state.user = payload;
    state.token = payload.token;
  },
  setError(state, payload) {
    state.error = payload;
  },
  setOrgUsers(state, payload) {
    state.orgUsers = payload;
  },
  setOrgDetails(state, payload) {
    state.orgDetails = payload;
  },
  setOrgUserLoadState(state, payload) {
    state.orgUserLoadState = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
